import vuewidget from './vuewidget'
import MiniCartWidget from '@/pages/MiniCartWidget.vue'

export default function (dom, opts) {
  // eslint-disable-next-line no-unused-vars
  const widget = vuewidget(dom, {
    vueComponent: MiniCartWidget,
    vueInit: 'initGlobal',
    ...opts
  })
}
